import type { ResumeData } from '../../lib/types';

export default function Education({ data }: { data: ResumeData }) {
  return (
    <section className="container-fluid">
      <h2>Education And Awards</h2>
      {(data.education ?? []).map((school, i) => (
        <div key={i} className="school">
          <div className="row">
            <div className="col-sm-6">
              <strong>{school.school}</strong>
              <br />
              <u>{school.degree}</u>
              <br />
              {(school.awards ?? []).join(', ')}
            </div>
            <div className="col-sm-6 text-right">{school.location}</div>
          </div>
        </div>
      ))}
    </section>
  );
}
